// advertisement
const Listpodcastcategory = () => import('@/views/podcast_category')
const Formapodcastcategory = () => import('@/views/podcast_category/form')
const Detailpodcastcategory = () => import('@/views/podcast_category/detail')

export default {
    path: 'podcast-category',
    redirect: '/podcast-category',
    component: {
        render(c) { return c('router-view') }
    },
    meta: {
        label: 'Category'
    },
    children: [{
            path: '/',
            name: 'podcast-category',
            component: Listpodcastcategory,
            meta: {
                auth: true,
                label: 'Podcast Category',
                permission: {
                    link: "podcast-category",
                    name: "Category",
                }
            }
        },
        {
            path: 'add',
            name: 'addpodcastcategory',
            component: Formapodcastcategory,
            meta: {
                auth: true,
                label: 'Add Podcast Category',
                permission: {
                    link: "podcast-category",
                    name: "Category",
                }
            }
        },
        {
            path: 'edit/:id',
            name: 'editpodcastcategory',
            component: Formapodcastcategory,
            meta: {
                auth: true,
                label: 'Edit Podcast Category',
                permission: {
                    link: "podcast-category",
                    name: "Category",
                },
            }
        },
        {
            path: ':id',
            name: 'detailpodcastcategory',
            component: Detailpodcastcategory,
            meta: {
                auth: true,
                label: 'Detail Podcast Category',
                permission: {
                    link: "podcast-category",
                    name: "Category",
                },
            }
        },
    ]
}